import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnLV: CultureInfo = {
  name: 'en-LV',
  displayName: 'English (Latvia)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-LV',
  parent: CultureInfoEn
};
